import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { SupabaseClient } from '../supabase/client';
import type {
  UpdateStoreManualOrderApprovalInput,
  UpdateStoreManualOrderApprovalResult,
} from '../types/store';
import { updateStoreManualOrderApproval } from '../services/update-store-manual-order-approval';

export function useUpdateStoreManualOrderApproval(
  client: SupabaseClient,
): UseMutationResult<
  UpdateStoreManualOrderApprovalResult,
  unknown,
  UpdateStoreManualOrderApprovalInput
> {
  const queryClient = useQueryClient();

  return useMutation<
    UpdateStoreManualOrderApprovalResult,
    unknown,
    UpdateStoreManualOrderApprovalInput
  >({
    mutationFn: (input) => updateStoreManualOrderApproval(client, input),
    onSuccess: (row, variables) => {
      queryClient.setQueryData(['store', variables.storeId], row);
    },
  });
}
